import { ToggleSwitch, Tooltip } from "flowbite-react"
import React from "react"
import { useTranslation } from "react-i18next"
import TableAction from "src/components/table/TableAction"

type TabletActionGroupProps = {
   activate?: boolean
   deactivate?: boolean
   delete?: boolean
   edit?: boolean
   view?: boolean
   showToggle?: boolean 
   isToggled?: boolean
   disableToggle?: boolean
   onToggleChange?: (checked: boolean) => void
   disableActivate?: boolean
   disableDeactivate?: boolean
   disableDelete?: boolean
   disableEdit?: boolean
   disableView?: boolean
   onActivateClick?: () => void
   onDeactivateClick?: () => void
   onDeleteClick?: () => void
   onEditClick?: () => void
   onViewClick?: () => void
}

type ActionItem = {
   type: 'view' | 'edit' | 'activate' | 'deactivate' | 'delete'
   disabled?: boolean
   onClick?: () => void
}

const TabletActionGroup: React.FC<TabletActionGroupProps> = (props) => {
   const [t] = useTranslation()

   const actions: ActionItem[] = []
   if (props.view) actions.push({ type: 'view', disabled: props.disableView, onClick: props.onViewClick })
   if (props.edit) actions.push({ type: 'edit', disabled: props.disableEdit, onClick: props.onEditClick })
   if (props.activate) actions.push({ type: 'activate', disabled: props.disableActivate, onClick: props.onActivateClick })
   if (props.deactivate) actions.push({ type: 'deactivate', disabled: props.disableDeactivate, onClick: props.onDeactivateClick })
   if (props.delete) actions.push({ type: 'delete', disabled: props.disableDelete, onClick: props.onDeleteClick })

   return (
      <div className="flex items-center">
         {actions.map((action, index) => (
            <TableAction
               key={action.type}
               action={action.type}
               disabled={action.disabled}
               onClick={action.onClick}
               isFirst={index === 0}
            />
         ))}
         {props.showToggle && (
            <div className={actions.length === 0 ? '' : 'ml-2.5'}>
               <Tooltip content={<p className="font-medium text-sm mb-0">{props.isToggled ? t(`common.deactivate`) : t(`common.activate`)}</p>}>
                  <ToggleSwitch
                     checked={!!props.isToggled}
                     disabled={props.disableToggle}
                     onChange={props.onToggleChange || (() => {})}
                     label=""
                     sizing="sm"
                     theme={{ toggle: { checked: { on: 'bg-[#62A4AB]', off: 'bg-twGray' }, sizes: { sm: 'after:border-0' } } }}
                  />
               </Tooltip>
            </div>
         )}
      </div>
   )
}

export default TabletActionGroup